import * as styles from './styles.css';
import SectionItem from './section-item';

export interface ISectionBodyProps {
  id: string;
  questions: { question: string; answer: string }[];
}

const SectionBody = ({ id, questions }: ISectionBodyProps) => {
  return (
    <div id={id} className={styles.section.questions}>
      {questions.map(({ question, answer }, index) => (
        <SectionItem
          key={`${question}-${index}`}
          id={`${id}-${index}`}
          question={question}
          answer={answer}
        />
      ))}
    </div>
  );
};

export default SectionBody;
